import { useController, useFormContext } from 'react-hook-form';
import { FormType, TripTypes } from '../../shared/models/form';

interface TripTypeProps {
  label: string;
  value: TripTypes;
}

const TripType = ({ label, value }: TripTypeProps) => {
  const { control } = useFormContext<FormType>();
  const {
    field: { onChange, onBlur, value: fieldValue, ref, name },
  } = useController({ control, name: 'tripType', rules: { required: true } });

  return (
    <div className="inline-flex gap-x-2 items-center">
      <input
        type="radio"
        id={value}
        checked={value === fieldValue}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        ref={ref}
        name={name}
        className="focus:ring-gray-500 focus:ring-2 rounded-full form-radio text-gray-500 border-gray-300 h-6 w-6"
      />
      <label htmlFor={value}>{label}</label>
    </div>
  );
};

export default TripType;
